import mergeObj from "../extraUtil/mergeTwoObj";
let chart = {
    "divlinealpha": "30",
    "divlinedashed": "1",
    "divlinedashlen": "5",
    "divlinedashgap": "5",
    "vdivlinealpha": "30",
    "divlinecolor": "#BEB2C8",
    "showlegend": "0",
    "updateanimduration": "0",
    "yaxisname": "Bill Amount ($)",
    "xaxisname": "Shipment Delay (Hrs)",
    "xaxismaxvalue": "50",
    "xaxisminvalue": "-50"
}

export default function dataSourceGenerator(rawData, timeSelectorValue, theme) {
    chart = mergeObj(chart, theme);
    let dataSource = {},
        dataset = [{
            "drawline": "0",
            "anchorsides": "0",
            "anchorradius": "7",
            "anchorbordercolor": "#89BBFE",
            "anchorborderthickness": "0",
            "anchorbgalpha": "70"
        }],
        data = [];
    for (let i = 0; i < rawData.length; i++) {
        let dataObj = {
            x: rawData[i]['shipmentDelay'],
            y: rawData[i]['payAmount'],
            anchorbgcolor: (function () {
                if (rawData[i]['delayKPI'] === "GOOD") {
                    return '#71B48D';
                } else if (rawData[i]['delayKPI'] === "OK") {
                    return '#65DEF1';
                } else {
                    return '#F4743B';
                }
            }()),
            tooltext: "<div><p>Shipment ID: " + rawData[i]['shipmentID'] + "</p><p>Shipment Delay(Hrs): " + rawData[i]['shipmentDelay'] + "</p><p>Bill Amount: $" + rawData[i]['payAmount'] + "</p><p>Customer Name: " + rawData[i]['customer'] + "</p>Delay KPI: " + rawData[i]['delayKPI'] + "</p>Destination Region: " + rawData[i]['destinationStateGroup'].toUpperCase() +"</div>"
        };
        data.push(dataObj);
        dataset[0]['data'] = data || [];
    }
    dataSource = {
        chart: chart,
        dataset: dataset
    }
    return dataSource
}


// WEBPACK FOOTER //
// ./src/util/dataSourceGenerators/shipmentDelayDistribution.js